import React from 'react';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export const ImageBadgeFreeDelivery: React.FC = () => {
  return (
    <Svg width="72" height="20" viewBox="0 0 72 20" fill="none">
      <Rect width="72" height="20" rx="10" fill="#FE9D1E" />
      <G clipPath="url(#clip0_4077_296432)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.9347 8.07507H42.1927L41.7163 9.63341H43.4583L43.9347 8.07507Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.8911 4.68347H34.5118L31.2048 15.5001H32.5841L35.8911 4.68347Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.1829 4.68347H36.8036L33.4966 15.5001H34.8759L38.1829 4.68347Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.6687 13.0252H31.0519L33.4901 5.05017H32.1069L29.6687 13.0252Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.6436 13.0252H28.0268L30.465 5.05017H29.0818L26.6436 13.0252Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.6531 7.43347H28.7148L28.3245 8.80847H32.2628L32.6531 7.43347Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.3716 11.6501H27.4333L27.0129 13.0251H30.9512L31.3716 11.6501Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.6043 9.3584H33.3994L32.979 10.7334H36.184L36.6043 9.3584Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.248 9.81677H18.8215L18.4011 11.1918H25.8276L26.248 9.81677Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7041 14.1251H20.0797L21.0886 10.8251H19.713L18.7041 14.1251Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8208 14.1251H23.1964L24.2053 10.8251H22.8297L21.8208 14.1251Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.1503 4.68347H43.0723L38.5933 8.4418H40.6713L45.1503 4.68347Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.468 8.44178H47.2952L45.6341 5.78345H43.8069L45.468 8.44178Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.3971 9.3584H37.9563L37.5359 10.7334H46.9767L47.3971 9.3584Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.001 13.0251H16.5654L16.145 14.4001H25.5806L26.001 13.0251Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6306 10.7334H7.18747L6.76709 12.1084H16.2102L16.6306 10.7334Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.073 5.05017H19.7329L19.3125 6.42517H26.6526L27.073 5.05017Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.6157 7.43347H19.2756L18.8552 8.80847H26.1953L26.6157 7.43347Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5396 5.05017H9.84567L9.42529 6.42517H17.1192L17.5396 5.05017Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4396 8.44177H8.65402L8.23364 9.81677H16.0192L16.4396 8.44177Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.793 9.81684H16.1686L17.6259 5.05017H16.2503L14.793 9.81684Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.19287 9.81684H9.56849L11.0258 5.05017H9.65019L8.19287 9.81684Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.66479 15.5001H11.2389L12.5561 11.1918H10.982L9.66479 15.5001Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8586 11.1918H19.2342L20.3833 7.43347H19.0077L17.8586 11.1918Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.8179 8.8085H26.1935L27.3425 5.05017H25.9669L24.8179 8.8085Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.608 11.6501C38.6407 11.6501 37.7869 12.2819 37.5041 13.2069L37.2376 14.0785C37.0215 14.7855 37.5503 15.5001 38.2895 15.5001H43.1569C44.1242 15.5001 44.978 14.8684 45.2608 13.9434L45.5272 13.0718C45.7434 12.3648 45.2146 11.6501 44.4753 11.6501H39.608ZM43.9956 13.2621C44.0316 13.1443 43.9434 13.0251 43.8202 13.0251H39.5758C39.2534 13.0251 38.9688 13.2357 38.8745 13.5441L38.7693 13.8882C38.7333 14.006 38.8214 14.1251 38.9446 14.1251H43.1891C43.5115 14.1251 43.7961 13.9146 43.8903 13.6062L43.9956 13.2621Z"
          fill="white"
        />
      </G>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.2307 4.375C60.9211 4.375 61.4807 4.93464 61.4807 5.625V6.875H62.4718C62.8033 6.875 63.1213 7.0067 63.3557 7.24112L64.8646 8.75C65.099 8.98442 65.2307 9.30236 65.2307 9.63388V13.125C65.2307 13.8154 64.6711 14.375 63.9807 14.375H63.874C63.6166 15.1032 62.9221 15.625 62.1057 15.625C61.2877 15.625 60.592 15.1012 60.3359 14.3706C60.3012 14.3735 60.2661 14.375 60.2307 14.375H56.374C56.1166 15.1032 55.4221 15.625 54.6057 15.625C53.7893 15.625 53.0948 15.1032 52.8374 14.375H52.7307C52.0404 14.375 51.4807 13.8154 51.4807 13.125V10.625H50.8557C50.5105 10.625 50.2307 10.3452 50.2307 10C50.2307 9.65482 50.5105 9.375 50.8557 9.375H51.4807V5.625C51.4807 4.93464 52.0404 4.375 52.7307 4.375H60.2307ZM52.7307 10.625H54.6057C54.9509 10.625 55.2307 10.3452 55.2307 10C55.2307 9.65482 54.9509 9.375 54.6057 9.375H52.7307V8.125H55.8557C56.2009 8.125 56.4807 7.84518 56.4807 7.5C56.4807 7.15482 56.2009 6.875 55.8557 6.875H52.7307V5.625H60.2307V13.125H56.374C56.1166 12.3968 55.4221 11.875 54.6057 11.875C53.7893 11.875 53.0948 12.3968 52.8374 13.125H52.7307V10.625ZM61.4807 11.9817C61.6762 11.9126 61.8866 11.875 62.1057 11.875C62.9221 11.875 63.6166 12.3968 63.874 13.125H63.9807V9.63388L62.4718 8.125H61.4807V11.9817ZM54.6057 14.375C54.2605 14.375 53.9807 14.0952 53.9807 13.75C53.9807 13.4048 54.2605 13.125 54.6057 13.125C54.9509 13.125 55.2307 13.4048 55.2307 13.75C55.2307 14.0952 54.9509 14.375 54.6057 14.375ZM61.4807 13.75C61.4807 14.0952 61.7605 14.375 62.1057 14.375C62.4509 14.375 62.7307 14.0952 62.7307 13.75C62.7307 13.4048 62.4509 13.125 62.1057 13.125C61.7605 13.125 61.4807 13.4048 61.4807 13.75Z"
        fill="white"
      />
      <Defs>
        <ClipPath id="clip0_4077_296432">
          <Rect
            width="41.25"
            height="11"
            fill="white"
            transform="translate(6.375 4.5)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
